import AddIcon from "@mui/icons-material/Add";
import { Alert } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState } from "react";
import { createProduct } from "../../api/products";
import Modal from "../elements/Modal";
import ProductForm from "./ProductForm";

export default function AddProduct({
  fetchData,
  token,
  setMessage,
  setSnackbarOpen,
}) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  
  const handleSubmit = async (values) => {
    setError(null);
    const priceWithoutCommas = values.price.replace(/,/g, '');

    try {
      const product = {
        ...values,
        title: values.title,
        price: priceWithoutCommas, 
      };
      const response = await createProduct(product, token);

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage("Product added successfully");
      fetchData();
      handleClose();
    } catch (error) {
      setError(error.message || "Failed to add a new product");
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  return (
    <div>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleClickOpen}
      >
        New Product
      </Button>
      <Modal
        open={open}
        modalTitle="Add Product"
        handleClose={handleClose}
        width={"sm"}
      >
        {error && <Alert severity="error">{error}</Alert>}
        <ProductForm onSubmit={handleSubmit} token={token} />
      </Modal>
    </div>
  );
}
